import React, { useContext, useEffect, useState } from "react";
import warning_icon from "../../assets/images/icons/warning_icon.png";

import "../../fonts/Futura-PT-Book.ttf";
import styles from "./Header.module.css";
import "./Slide.css";

import cart_icon from "../../assets/images/icons/shopping_cart_icon.png";
import { Link } from "react-router-dom";
import AuthContext from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import useAxios from "../Hooks/useAxios";

const Header = ({ cartChanged }) => {
  const navigate = useNavigate();
  const { user, logout } = useContext(AuthContext);
  const [hamMenu, setHamMenu] = useState(false);
  const axios = useAxios();
  const backend_base = process.env.REACT_APP_API_BASE_URL;

  const [cartItemCount, setCartItemCount] = useState(0);

  useEffect(() => {
    axios
      .get(backend_base + "/order/cart/count")
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          console.log("Success Getting Cart Count Items");
          console.log(res.data);
          setCartItemCount(res.data.cart_count);
        } else {
          console.log("Failed");
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, [cartChanged]);

  const [notifications, setNotifications] = useState({
    gallery: false,
    design: false,
    onlineshop: false,
  });
  useEffect(() => {
    axios
      .get(backend_base + "/user/my-page")
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          console.log("Success Getting Cart Count Items");
          console.log(res.data);
          setNotifications(res.data);
        } else {
          console.log("Failed");
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);
  return (
    <>
      <div className={styles.header}>
        <div className={`${styles.header_body}`}>
          <div className={styles.header_body_element1_wrapper}>
            <Link className={styles.header_body_element1} to="/">
              My Ace
            </Link>
          </div>
          <div className={styles.second_sec}>
            {user ? (
              <span className={styles.header_body_element2}>
                {user.kanji_first_name + " " + user.kanji_last_name}
              </span>
            ) : (
              <Link to="/register" className={styles.header_body_element2}>
                会員登録
              </Link>
            )}

            {user ? (
              <Link to="/top" className={styles.header_body_element2}>
                マイページ{" "}
                {(notifications.gallery ||
                  notifications.design ||
                  notifications.onlineshop) && (
                  <img
                    src={warning_icon}
                    style={{
                      width: "23px",
                      height: "23px",
                      transform: "translateY(-10px) translateX(-15px)",
                    }}
                    alt="warning"
                  />
                )}
              </Link>
            ) : (
              <Link to="/login" className={styles.header_body_element2}>
                ログイン
              </Link>
            )}
            <div
              id={styles.cart_icon_div}
              className={styles.header_body_element2}
              onClick={() => {
                if (user) {
                  navigate("/cart");
                } else {
                  navigate("/cart-front");
                }
              }}
            >
              {/* <BsFillCartFill className={styles.header_body_element4} /> */}
              <img
                src={cart_icon}
                height={"28px"}
                width={"24px"}
                alt="cart"
                className={styles.header_body_element4}
              />
              {cartItemCount > 0 && (
                <div className={styles.cart_badge_main}>{cartItemCount}</div>
              )}
            </div>

            <div
              onClick={() => {
                console.log("ham open click received!");
                setHamMenu(!hamMenu);
              }}
              className={styles.fake_ham_height_wrapper}
            >
              <div className={styles.fake_ham_menu_main}>
                <div className={styles.fake_ham_menu_bar}></div>
                <div className={styles.fake_ham_menu_bar}></div>
                <div className={styles.fake_ham_menu_bar}></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`hamburger_menu ${hamMenu ? "active" : ""}`}
        style={{ top: 0, transition: ".3s ease-in", zIndex: 101 }}
      >
        <div
          className={styles.close_hamburger}
          onClick={() => setHamMenu(!hamMenu)}
        >
          <ion-icon name="close"></ion-icon>
        </div>
        <div className={styles.ham_text_main_div}>
          <div
            className={styles.ham_text_1}
            onClick={() => {
              navigate("/");
            }}
          >
            My Ace Top
          </div>
          {user && (
            <div
              onClick={() => {
                navigate("/top");
              }}
              className={styles.ham_text_3}
            >
              マイページ
            </div>
          )}

          <div
            onClick={() => {
              navigate("/features");
            }}
            className={styles.ham_text_1}
          >
            My Aceの特徴
          </div>
          <div
            onClick={() => {
              navigate("/usage-flow");
            }}
            className={styles.ham_text_2}
          >
            ご利用の流れ
          </div>
          <div
            onClick={() => {
              navigate("/faq");
            }}
            className={styles.ham_text_3}
          >
            よくある質問
          </div>
          <div
            onClick={() => {
              navigate("/gallery-front");
            }}
            className={styles.ham_text_4}
          >
            Gallery
          </div>
          <div
            onClick={() => {
              navigate("/design-box");
            }}
            className={styles.ham_text_4}
          >
            Design
          </div>
          <div
            onClick={() => {
              navigate("/onlineshop");
            }}
            className={styles.ham_text_4}
          >
            Online Shop
          </div>
          <div
            onClick={() => {
              window.open("https://acestudio.jp/", "_blank");
            }}
            className={styles.ham_text_1}
          >
            Acestudio HP
          </div>
          <div className={styles.spacing04}></div>
          <div className={styles.menu_buttons}>
            {!user && (
              <>
                <div>
                  <button
                    className={styles.hamburger_button}
                    onClick={() => {
                      navigate("/login");
                    }}
                  >
                    ログイン
                  </button>
                </div>
                <div>
                  <button
                    className={styles.hamburger_button}
                    onClick={() => {
                      navigate("/register");
                    }}
                  >
                    会員登録
                  </button>
                </div>
              </>
            )}
            {user && (
              <div>
                <button
                  className={styles.hamburger_button}
                  onClick={() => {
                    logout();
                    localStorage.setItem("logoutMessage", true);
                    navigate("/logout-success");
                  }}
                >
                  ログアウト
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
